import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faPen, faX } from '@fortawesome/free-solid-svg-icons';
import { Grid } from '../../components/grid';
import Formulario from './formulario';
import { FormularioModal } from '../../components/ventanaModal';
import { AgregarRol, ActualizarRol, InactivarRol, ObtenerRoles, ObtenerRol } from '../../servicios/ServicioRoles'
import { AlertDismissible } from '../../components/alerts';
import { ConfirmModal } from '../../components/ConfirmModal';


const Roles = () => {
    const [proceso, setProceso] = useState(1);
    const [modal, setModal] = useState(false);
    const [modalTitulo, setModalTitulo] = useState("Registrar rol");
    const [labelButton, setLabelButton] = useState("Registrar");
    const [mensajeFormulario, setMensajeFormulario] = useState("");
    const [mensajeRespuesta, setMensajeRespuesta] = useState({});
    const [showAlert, setShowAlert] = useState(false);
    const [confirmModalOpen, setConfirmModalOpen] = useState(false);

    const [listaDeRoles, setListaDeRoles] = useState([]);
    const [pendiente, setPendiente] = useState(false);
    const [filaSeleccionada, setFilaSeleccionada] = useState({});
    const [data, setData] = useState({});
    const [bloquearBoton, setBloquearBoton] = useState(true);
    const [textoBotonInactivar, setTextoBotonInactivar] = useState("Inactivar");


    const encabezado = [
        { id: 'id', name: 'id', selector: row => row.id, head: "id", omit: true },
        { id: 'descripcion', name: 'Descripción', selector: row => row.descripcion, head: "Descripcion", sortable: true },
        { id: 'Estado', name: 'Estado', selector: row => row.estado, head: "Estado", sortable: true }
    ]

    //Se indica las columnas en las que se aplica el filtro
    const filterColumns = ['descripcion', 'estado'];

    useEffect(() => {
        ObtenerListadoDeRoles();

    }, []);

    const onClickNuevoRol = () => {
        setProceso(1);
        setModal(!modal);
        setLabelButton("Registrar");
        setModalTitulo("Registrar rol");
    }

    const onClickActualizarRol = async () => {
        setData(await ObtenerRol(filaSeleccionada.idRol));

        setProceso(2);
        setModal(!modal);
        setLabelButton("Actualizar Nombre");
        setModalTitulo("Actualizar rol");

    }

    const onClickInactivarRol = async () => {
        setConfirmModalOpen(true);
    }

    const onConfirmCambioEstado = async () => {
        const respuesta = await InactivarRol(filaSeleccionada.idRol)
        if (respuesta.indicador === 0)
            ObtenerListadoDeRoles();
        setMensajeRespuesta(respuesta);

        setTextoBotonInactivar(textoBotonInactivar === "Activar" ? "Inactivar" : "Activar");
        setConfirmModalOpen(false);
        setShowAlert(true);
    }

    const ObtenerListadoDeRoles = async () => {
        setPendiente(true);
        setListaDeRoles(await ObtenerRoles());
        setPendiente(false);
    }

    const onClickProcesarRol = async (data) => {


        let usuario = JSON.parse(sessionStorage.getItem("data_usuario"));
        const listaPermisos = [
            {
                idRol: data.idRol,
                usuarioModificacion: usuario.idUsuario,

                //Generales
                permisoAgregar: data.permisos.permisoAgregar,
                permisoActualizar: data.permisos.permisoActualizar,
                permisoEliminar: data.permisos.permisoEliminar,

                //Club de viajes
                permisoAbonoC: data.permisos.permisoAbonoC,
                permisoLoteria: data.permisos.permisoLoteria,
                permisoComentarioC: data.permisos.permisoComentarioC,
                permisoDocumentoC: data.permisos.permisoDocumentoC ,

                //Paquete de viajes
                permisoAbonoP: data.permisos.permisoAbonoP,
                permisoSeguroCliente: data.permisos.permisoSeguroCliente,
                permisoHabitacionCliente: data.permisos.permisoHabitacionCliente,
                permisoTourCliente: data.permisos.permisoTourCliente,
                permisoAcompanante: data.permisos.permisoAcompanante,
                permisoTourAcompanante: data.permisos.permisoTourAcompanante,
                permisoHabitacionAcompanante: data.permisos.permisoHabitacionAcompanante,
                permisoSeguroAcompanante: data.permisos.permisoSeguroAcompanante,
                permisoComentarioP: data.permisos.permisoComentarioP,
                permisoDocumentoP: data.permisos.permisoDocumentoP
            }
        ];

        setMensajeFormulario("");
        let respuesta = {};
        if (proceso === 1)
            respuesta = await AgregarRol({ ...data, permisos: listaPermisos });
        else {
            data.idRol = filaSeleccionada.idRol;
            data.estado = true;
            respuesta = await ActualizarRol({ ...data, permisos: listaPermisos });
        }

        if (respuesta.indicador != 0) {
            setMensajeFormulario(respuesta.mensaje);
        }

        if (respuesta.indicador == 0) {
            setModal(false);
            ObtenerListadoDeRoles();
            setMensajeRespuesta(respuesta);
        }
        //else {
        //    setMensajeFormulario(respuesta);
        //}
        setShowAlert(true);
    }

    const onClickSeleccionarFila = (fila) => {
        const filaValida = ValidarSiFilaFueSeleccionada(fila);
        setBloquearBoton(!filaValida);
        setTextoBotonInactivar(!filaValida ? "Inactivar" : (fila.estado == "Activo" ? "Inactivar" : "Activar"));
        setFilaSeleccionada(fila);
    }

    const onClickCerrarModal = () => {
        setModal(false);
        setMensajeFormulario("");
    }

    const ValidarSiFilaFueSeleccionada = (fila) => Object.entries(fila).length === 0 ? false : true;

    return (
        <>
            <div className="container-fluid">
                <h1>Mantenimiento de roles</h1>
                <hr />
                <Button
                    className="mr-1 mb-2 card-button"
                    variant="primary"
                    type="submit"
                    size="sm"
                    onClick={() => onClickNuevoRol()}>
                    <FontAwesomeIcon icon={faPlus} className="mr-2" />
                    Registrar
                </Button>{' '}
                <Button
                    className="mr-1 mb-2 card-button"
                    variant="primary"
                    type="submit"
                    size="sm"
                    onClick={() => onClickActualizarRol()}
                    disabled={bloquearBoton}>
                    <FontAwesomeIcon icon={faPen} className="mr-2" />
                    Actualizar
                </Button>{' '}
                <Button
                    className="mr-1 mb-2 danger-button"
                    variant="danger"
                    type="submit"
                    size="sm"
                    onClick={() => onClickInactivarRol()}
                    disabled={bloquearBoton}>
                    <FontAwesomeIcon icon={faX} className="mr-2" />
                    {textoBotonInactivar}
                </Button>
                <br /><br />
                {showAlert && (
                    <AlertDismissible
                        indicador={mensajeRespuesta.indicador}
                        mensaje={mensajeRespuesta.mensaje}
                        setShow={setShowAlert}
                    />
                )} 
                <span>Listado de todos los roles registrados</span>
                <Grid gridHeading={encabezado} gridData={listaDeRoles} selectableRows={true} pending={pendiente}
                    setFilaSeleccionada={onClickSeleccionarFila} idBuscar="idRol" filterColumns={filterColumns} />
                <br /><br />
            </div>
            <FormularioModal show={modal} handleClose={onClickCerrarModal} titulo={modalTitulo} className='' tamano="lg">
                <Formulario labelButton={labelButton} data={data} proceso={proceso} onClickProcesarRol={onClickProcesarRol} mensaje={mensajeFormulario} />
            </FormularioModal>
            {confirmModalOpen && (
                <ConfirmModal
                    isOpen={confirmModalOpen}
                    toggle={() => setConfirmModalOpen(!confirmModalOpen)}
                    message={`¿Desea cambiar el estado del rol a ${textoBotonInactivar === "Activar" ? "activo" : "inactivo"
                        }?`}
                    onConfirm={onConfirmCambioEstado}
                />
            )}
        </>
    )
}

export default Roles;